import { TestId } from "../testIdType"

export const testId: TestId = {
    email: "email",
    forgotPassword: "forgot-password",
    forgotPasswordSubmit: "forgot-password-submit",
    login: "login",
    password: "password",
    submitEnter: "submit-enter"
}
